<template>
  <div id="service-area" class="service-area bg-sky pd-top-110 bg-relative">
    <img
      class="left_image_bounce position-top-right"
      :src="require('@/assets/img/about/4.png')"
      alt="img"
    />
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <div class="section-title text-center">
            <h6 class="sub-title">Nuestras opciones</h6>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-6">
          <div class="single-service-inner">
            <div class="thumb">
              <img
                :src="require('@/assets/img/icon/service-1.png')"
                style="height: 90px; width: 90px;"
                alt="img"
              />
            </div>
            <div class="details">
              <h4>Desarrollo de Aplicaciones Web y Móviles</h4>
              <p style="text-align: justify;">
                Creamos aplicaciones web y móviles a medida, utilizando las
                últimas tecnologías y enfoques ágiles. Desde sitios web
                responsivos hasta aplicaciones móviles nativas, nuestros
                desarrolladores experimentados están listos para hacer realidad
                tus ideas.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="single-service-inner">
            <div class="thumb">
              <img
                :src="require('@/assets/img/icon/service-2.png')"
                style="height: 90px; width: 90px;"
                alt="img"
              />
            </div>
            <div class="details">
              <h4>Arquitectura de Software</h4>
              <p style="text-align: justify;">
                Nuestros expertos en arquitectura de software diseñarán y
                desarrollarán una estructura sólida y escalable para tus
                sistemas, garantizando la eficiencia y el rendimiento óptimo en
                cada etapa del proceso.
              </p>
              <br /><br />
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="single-service-inner">
            <div class="thumb">
              <img
                :src="require('@/assets/img/icon/service-5.png')"
                style="height: 90px; width: 90px;"
                alt="img"
              />
            </div>
            <div class="details">
              <h4>Gestión de Proyectos</h4>
              <p style="text-align: justify;">
                Ofrecemos servicios completos de gestión de proyectos, desde la
                planificación y la asignación de recursos hasta el seguimiento y
                la entrega exitosa. Nuestro enfoque centrado en la comunicación
                y la colaboración garantiza que tus proyectos se completen a
                tiempo y dentro del presupuesto.
              </p>
              <br />
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="single-service-inner">
            <div class="thumb">
              <img
                :src="require('@/assets/img/icon/service-3.png')"
                style="height: 90px; width: 90px;"
                alt="img"
              />
            </div>
            <div class="details">
              <h4>Consultoría y Asesoramiento Técnico</h4>
              <p style="text-align: justify;">
                Nuestro equipo de consultores técnicos está listo para brindarte
                orientación y asesoramiento experto en el uso de tecnologías y
                herramientas específicas para maximizar tu eficiencia y lograr
                tus objetivos empresariales.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="single-service-inner">
            <div class="thumb">
              <img
                :src="require('@/assets/img/icon/service-4.png')"
                style="height: 90px; width: 90px;"
                alt="img"
              />
            </div>
            <div class="details">
              <h4>Mantenimiento y Soporte</h4>
              <p>
                Además del desarrollo de software, ofrecemos servicios de
                mantenimiento y soporte continuo para garantizar el rendimiento
                óptimo de tus aplicaciones y sistemas. Estamos aquí para
                solucionar problemas, aplicar actualizaciones y brindar
                asistencia técnica en todo momento.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceArea"
};
</script>



// WEBPACK FOOTER //
// src/components/page/service/ServiceArea.vue